import { SelectReferralSource } from '@/shared/components/select-referral-source';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { putClientReferralSourceByClientIdRequest } from '@/model/clientModel';

interface ReferralSourceCellProps {
  client: Client;
  advisor: Advisor;
  disabled?: boolean;
}

export function ReferralSourceCell({ client, advisor, disabled }: ReferralSourceCellProps) {
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (value: string | undefined) => {
      dispatch(
        putClientReferralSourceByClientIdRequest({
          clientId: client.clientId,
          advisorReferralSourceId: value,
          advisorId: advisor.advisorId,
        }),
      );
    },
    [dispatch, client.clientId, advisor.advisorId],
  );

  return (
    <div
      aria-disabled={disabled}
      className="w-max aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>div]:gap-0 [&_label]:hidden"
    >
      <SelectReferralSource
        selectedReferralSourceId={client.clientReferralSourceId}
        onChangeReferralSourceId={handleChange}
        className="h-6.5! px-2! w-max rounded-full border text-xs"
      />
    </div>
  );
}
